import axios from 'axios'

axios.defaults.baseURL = 'https://my-room-abroad.firebaseio.com/'
